import { useEffect, useRef } from 'react';

export default function useFormPersist(pageName, values, onChange) {
  const key = `vedic_${pageName}_form`;
  const initialized = useRef(false);

  // Restore on mount
  useEffect(() => {
    if (initialized.current) return;
    initialized.current = true;
    try {
      const cached = sessionStorage.getItem(key);
      if (cached) {
        const parsed = JSON.parse(cached);
        onChange(prev => ({ ...prev, ...parsed }));
      }
    } catch { /* storage unavailable */ }
  }, [key, onChange]);

  // Persist on change
  useEffect(() => {
    if (!initialized.current) return;
    try {
      sessionStorage.setItem(key, JSON.stringify(values));
      // Also update global last-used data (for cross-page pre-fill)
      if (values.dob && values.place) {
        sessionStorage.setItem('vedic_last_birthdata', JSON.stringify(values));
      }
      if (values.place && (values.lat || values.latitude)) {
        sessionStorage.setItem('vedic_last_place', JSON.stringify({
          place: values.place, lat: values.lat || values.latitude, lon: values.lon || values.longitude, timezone: values.timezone,
        }));
      }
    } catch { /* storage full */ }
  }, [key, values]);
}
